module.exports = __webpack_public_path__ + "img/9788936509859.8457e9fe.jpg";